import { SET_VIEW } from 'store/constants/action-types';

export const setViewAction = (payload) => {
  return { type: SET_VIEW, payload: payload };
};
